import { ENV } from "@/core/config/env";
import routeTenant from "@/core/services/routeTenant.service";
const baseUrlTenant = routeTenant.routeBaseConfig();
const historyLog = [
    {
        // path: baseUrlTenant+"/history-9obi5kb2UiLCJ0b2tlbiI6InNlY3JldDEyMyJ9" ,
        path: baseUrlTenant+"/history" ,
        component: () => import("@/view/layout/Layout"),
        children: [
            {
                name: "history",
                path: "/",
                component: () => import("@/view/pages/history/index")
            }
        ]
    },
]
export default historyLog;
